<template>

</template>


<script>
export default {
    name: "product_preview",
    props : {
        products : {
            type : Object
        }
    }
}
</script>


<style scoped>

</style>
